import { render, staticRenderFns } from "./AdminSelect.vue?vue&type=template&id=5563c288&"
import script from "./AdminSelect.vue?vue&type=script&lang=js&"
export * from "./AdminSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports